/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ElectronicStatementsDownloadModelDto,
  ReportInformationModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ElectronicdocumentsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsDownloadElectronicDocument
   * @summary Gets the electronic document report.
   * @request POST:/electronicdocuments/download
   */
  electronicStatementsDownloadElectronicDocument = (
    model: ElectronicStatementsDownloadModelDto | null,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/electronicdocuments/download`,
      method: "POST",
      body: model,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsGetElectronicDocumentList
   * @summary Gets the electronic document list.
   * @request GET:/electronicdocuments/{productName}/reportlist/{accountId}
   */
  electronicStatementsGetElectronicDocumentList = (
    productName: string,
    accountId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<ReportInformationModelDto[], any>({
      path: `/electronicdocuments/${productName}/reportlist/${accountId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
